export default __webpack_public_path__ + "static/media/Path 131.e81fb23d.svg";